interface OptionItem {
  id: string;
  label: string;
  imageUrl?: string;
}

interface SingleSelectListProps {
  options: OptionItem[];
  value?: string;
  onChange: (id: string) => void;
}

export function SingleSelectList({ options, value, onChange }: SingleSelectListProps) {
  // Visual-preference questions: every option has an image. Render as a
  // 2-column tile grid so the images are the primary selection target.
  const allHaveImages = options.length > 0 && options.every((o) => Boolean(o.imageUrl));
  if (allHaveImages) {
    return (
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {options.map((opt) => {
          const selected = value === opt.id;
          return (
            <li key={opt.id}>
              <button
                type="button"
                onClick={() => onChange(opt.id)}
                aria-pressed={selected}
                aria-label={opt.label}
                className={`w-full overflow-hidden rounded-cta border-2 transition-all duration-100 ${
                  selected
                    ? 'border-ink shadow-[4px_4px_0_0_rgba(15,18,23,1)]'
                    : 'border-ink/10 hover:border-ink hover:-translate-y-0.5 hover:shadow-card'
                }`}
              >
                <div className="aspect-square bg-canvas-subtle">
                  <img
                    src={opt.imageUrl}
                    alt=""
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <ul className="space-y-2.5">
      {options.map((opt) => {
        const selected = value === opt.id;
        return (
          <li key={opt.id}>
            <button
              type="button"
              onClick={() => onChange(opt.id)}
              aria-pressed={selected}
              className="option-card"
            >
              {opt.label}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
